// extracted by mini-css-extract-plugin
module.exports = {"select":"select__2vo6P","menu":"menu__1pchX"};